export enum UserAddressesEndpointsEnum {
  USER_ADDRESS_LIST = "/user-addresses",
  CREATE_USER_ADDRESS = "/user-addresses",
  UPDATE_USER_ADDRESS = "/user-addresses/:user_address_id",
  DELETE_USER_ADDRESS = "/user-addresses/:user_address_id",
  USER_ADDRESS_DETAIL = "/user-addresses/:user_address_id",
}
